import { useQuery } from "@tanstack/react-query";
import { getImageCompressionCacheStats } from "../openapi/api-client.ts";

export const useImageCompressionCacheStats = (
  projectId: string,
  appInstallationId: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["imageCompressionCacheStats", { projectId, appInstallationId }],
    queryFn: async () => {
      const response = await getImageCompressionCacheStats({
        path: { projectId, appInstallationId },
      });

      if (response.error) {
        throw new Error(
          response.error.message ||
            "error while fetching image compression cache stats",
        );
      }

      return response.data;
    },
    enabled,
    staleTime: 60 * 60 * 1000, // 1 hour
  });
};
